<div class="input-dropdown-menu-container" [ngStyle]="{ position: variant === 'standard' ? 'relative' : {} }">

    @if(variant === 'header'){ @if(label){
    <span class="placeholder" aria-hidden="true">
        {{ label }}
    </span>
    }
    <button id="{{ 'dropdown-menu-outer-button-' + name }}" [disabled]="disabled" tabindex="0" #outerButton
        (click)="this.handleDisplaySuggestions(disabled)" (keydown)="onKeyDownButton($event)" [ngClass]="{
            'dropdown-menu-outer-button': true,
            'dropdown-menu-outer-button-opened': displaySuggestions,
            'dropdown-menu-outer-button--selected': selected
        }" [attr.aria-label]="placeholder + ' desplegable '">
        <div class="outer-button-text">
            <span class="placeholder" aria-hidden="true">
                {{ placeholder }}
            </span>
        </div>
        <span class="material-symbols-outlined" aria-hidden="true">
            {{ displaySuggestions ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
    </button>

    @if(this.displaySuggestions){
    <div [id]="'dropdown-menu-suggestions-container-' + name" class="dropdown-menu-suggestions-container mega-menu"
        #suggestionsContainer>

        <button type="button" class="mega-menu__close" (click)="displaySuggestions = false">
            Cerrar
            <span class="material-symbols-outlined">close</span>
        </button>

        <!-- COLUMNA IZQUIERDA -->
        <div class="mega-menu__image">
            <img [src]="dropdownImage" alt="Dropdown Image">
        </div>

        <!-- COLUMNA CENTRO -->
        <div class="mega-menu__main" [class.mega-menu__main--with-divider]="activeSuggestion?.subdropdown?.length">

            @for(suggestion of suggestions; track suggestion.name){

            <button id="dropdown-menu-item-{{ suggestion.name }}" type="button" class="mega-menu__dropdown-item"
                [class.active]="activeSuggestion === suggestion"
                (click)="suggestion.subdropdown?.length? setActiveSuggestion(suggestion) : onClickSuggestion(suggestion)">

                <span>{{ suggestion.name }}</span>

                @if(suggestion.subdropdown?.length){
                <span class="material-symbols-outlined">
                    chevron_right
                </span>
                }

            </button>

            }

        </div>

        <!-- COLUMNA DERECHA -->
        <div class="mega-menu__secondary">

            @if(activeSuggestion?.subdropdown?.length){

            <div class="mega-menu__subdropdown-title">
                {{ activeSuggestion?.name }}
            </div>

            @for(subdropdown of activeSuggestion?.subdropdown; track subdropdown.name){
            <a class="mega-menu__subdropdown-item" [routerLink]="$any(subdropdown.url)"
                (click)="displaySuggestions = false">
                {{ subdropdown.name }}
            </a>
            }

            }

        </div>

    </div>
    }

    } @else if (variant === 'mobile') {

    <div class="mobile-dropdown">

        <button class="mobile-dropdown-title" (click)="handleDisplaySuggestions(disabled)">

            <span>{{ placeholder }}</span>

            <span class="material-symbols-outlined">
                {{ displaySuggestions ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
            </span>

        </button>

        @if(displaySuggestions){

        <div class="mobile-dropdown-items">

            @for(suggestion of suggestions; track suggestion.name) {

            @if(suggestion.subdropdown?.length){

            <button type="button" class="mobile-dropdown-item mobile-dropdown-item--submenu"
                (click)="openMobileSubmenu(suggestion)">

                <span>{{ suggestion.name }}</span>

                <span class="material-symbols-outlined">
                    chevron_right
                </span>

            </button>

            } @else {

            <button type="button" class="mobile-dropdown-item" (click)="onClickSuggestion(suggestion)">

                {{ suggestion.name }}

            </button>

            }

            }

        </div>

        }

    </div>

    }
</div>